import {IWineShop} from 'modules/wineshops-list/models';
import {createContext, Dispatch, SetStateAction} from 'react';
import {IReviewsTotal, TGetReviewsTransformedResponse} from 'modules/product-card/models/Review';
import {IExpressOrder} from 'plugins/modules/filter/types';
import {ISeo} from 'modules/seo/types';

interface IProductPageContextProps {
    canBuy?: boolean;
    seo?: ISeo | null;
    canReserve?: boolean;
    onReserveProduct?: (wineShop: IWineShop) => void;
    onSelectShop?: (wineShop: IWineShop) => void;
    reviews?: TGetReviewsTransformedResponse;
    reviewsTotal?: IReviewsTotal;
    setWineshopForReserveProduct?: Dispatch<SetStateAction<IWineShop | undefined>>;
    wineshopForReserveProduct?: IWineShop;
    wineshopsForTodayWithStock: IWineShop[];
    expressWineshop?: IExpressOrder;
    isExpressWineshopLoading?: boolean;
    // флаг поведения после выбора карты: добавить в корзину (true) или открыть окно бронирования
    isAddToCartWhenReserving?: boolean;
    setIsAddToCartWhenReserving?: Dispatch<SetStateAction<boolean>>;
}

export const ProductPageContext = createContext<IProductPageContextProps>({
    wineshopsForTodayWithStock: [],
});
